module.exports = __webpack_public_path__ + "img/remove.6ed6a17.svg";